import { render, staticRenderFns } from "./menuOrg.vue?vue&type=template&id=d28949ca&scoped=true"
import script from "./menuOrg.vue?vue&type=script&lang=js"
export * from "./menuOrg.vue?vue&type=script&lang=js"
import style0 from "./menuOrg.vue?vue&type=style&index=0&id=d28949ca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28949ca",
  null
  
)

export default component.exports